import React from 'react';
import classnames from 'classnames';
import Sticky from '@wix/da-shared-react/pkg/Sticky';

import s from './WidgetHeaderWide.scss';

export interface Props {
  header: string | React.ReactNode;
  extras?: React.ReactNode | React.ReactNode[];
  extrasWhenSticky?: React.ReactNode | React.ReactNode[];
  subHeader?: string;
  className?: string;
  isSticky?: boolean;
}

export class WidgetHeaderWide extends React.Component<Props> {
  render() {
    const { isSticky = false } = this.props;
    return isSticky ? (
      <Sticky className={s['sticky']} marginTop={54}>
        {isStuck => this.renderInner(isStuck)}
      </Sticky>
    ) : (
      this.renderInner()
    );
  }

  renderInner(isStuck = false) {
    const {
      className,
      header,
      subHeader,
      extras,
      extrasWhenSticky,
    } = this.props;
    return (
      <div
        className={classnames(s['root'], isStuck && s['root-stuck'], className)}
      >
        <h3 className={s['header']}>{header}</h3>
        {subHeader && <div className={s['sub-header']}>{subHeader}</div>}
        {isStuck ? extrasWhenSticky : extras}
      </div>
    );
  }
}

export default WidgetHeaderWide;
